export interface HomeStructureCondition {
  roofType: RoofType;
  structureDamages: StructureDamages;
  plumbingType?: PlumbingType;
  roofReplacementYear?: number;
}

// Represent all plumbing type choices
export enum PlumbingType {
  Abs = 'abs',
  Copper = 'copper',
  CopperAndAbs = 'copperAndAbs',
  Galvanized = 'galvanized',
  Iron = 'iron',
  Other = 'other',
  Pex = 'pex',
  Pvc = 'pvc',
  PolyB = 'polyB',
  Kitec = 'kitec',
}

// Represent all roof roof types
export enum RoofType {
  Asphalt = 'asphalt',
  Wood = 'wood',
  Clay = 'clay',
  Tar = 'tar',
  Metal = 'metal',
  Other = 'other',
  Rubber = 'rubber',
}

// Represents structure damages
export enum StructureDamages {
  None = 'none',
  Repaired = 'repaired',
  Damaged = 'damaged',
}
